const BASIC_TOKEN = process.env.VUE_APP_BASIC_TOKEN;
import axios from 'axios';
import { EventBus } from '@/eventBus';
import {
    STORAGE_ORDER_SCRIPS,
    STORAGE_ORDER_FORM
} from '@/constants/order';

function syncResponseAuthHeaders(vm, response) {
    const headers = response?.headers || {};
    const nextToken = headers['x-auth-token'];
    const nextExpiration = headers['x-api-token-expires'];
    const nextUserId = headers['x-user-id'];
    const previousToken = window.localStorage.getItem('token');

    if (!vm?.$auth) {
        return;
    }

    if (nextToken) {
        vm.$auth.setToken(nextToken, nextExpiration);

        if (previousToken && previousToken !== nextToken) {
            EventBus.$emit('auth-token-updated', nextToken);
        }
    } else if (nextExpiration) {
        vm.$auth.updateTokenExpiration(nextExpiration);
    }

    if (nextUserId) {
        window.localStorage.setItem('user_id', String(nextUserId));
    }
}

export function check401() {
    axios.interceptors.response.use(
        response => {
            syncResponseAuthHeaders(this, response);
            return response;
        },
        error => {
            if (error?.response) {
                syncResponseAuthHeaders(this, error.response);
            }

            if (401 === error.response.status) {
                this.$auth.destroyToken("http_401", {
                    requestMethod: error.config?.method || null,
                    requestUrl: error.config?.url || null,
                    status: error.response.status,
                });
                this.$onlineToken.destroy();
                window.location.reload();
                window.sessionStorage.removeItem("show-order-scripts");
                window.sessionStorage.removeItem(STORAGE_ORDER_FORM);
                window.sessionStorage.removeItem(STORAGE_ORDER_SCRIPS);
            } else {
                return Promise.reject(error);
            }
        }
    );
}

export function setAuthHeaders() {
    axios.interceptors.request.use(
        config => {
            config.headers.Authorization = `Basic ${window.localStorage.getItem('token')}`;
            config.headers['X-Data-Access-Type'] = window.localStorage.getItem('type');
            config.headers['X-User-Id'] = window.localStorage.getItem('user_id');
            config.headers['X-Data-Username'] = window.localStorage.getItem('username');
            config.headers['X-Data-Request-Type'] = 'cabinet';
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

            return config;
        },
        error => Promise.reject(error)
    );
}

export function setNotAuthHeaders() {
    axios.interceptors.request.use(
        config => {
            config.headers.Authorization = `Basic ${BASIC_TOKEN}`;
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

            return config;
        },
        error => Promise.reject(error)
    );
}

export function setIframeAuthHeaders(token, operator, name = 'iframe', type = 'user') {
    axios.interceptors.request.use(
        config => {
            config.headers.Authorization = `Basic ${token}`;
            config.headers['X-Data-Username'] = operator;
            config.headers['X-Data-Access-Type'] = type;
            config.headers['X-Data-Request-Type'] = name;
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

            return config;
        },
        error => Promise.reject(error)
    );
}

export function setOnlineToken(token) {
    axios.interceptors.request.use(
        config => {
            config.headers['X-Online-Token'] = token;
            return config;
        },
        error => Promise.reject(error)
    )
}
